// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar_calendar__EHNS9","date":"calendar_date__BllIt","month":"calendar_month__2GQK-"};